import { render, staticRenderFns } from "./InsuranceExplanation.vue?vue&type=template&id=4079242a&scoped=true"
import script from "./InsuranceExplanation.vue?vue&type=script&lang=js"
export * from "./InsuranceExplanation.vue?vue&type=script&lang=js"
import style0 from "./InsuranceExplanation.vue?vue&type=style&index=0&id=4079242a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4079242a",
  null
  
)

export default component.exports